module.exports = __webpack_public_path__ + "img/changchun.85d9caaf.png";